// https://www.makeuseof.com/create-protected-route-in-react/
import React from 'react';
import './App.css';
// import { matchPath } from 'react-router';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Login,
  ForgotPassword,
  ResetPassword,
  Otp,
  Register,
  Logout,
  SuperAdmin,
  Profile,
  // Navigation,
  // Footer,
  Reports,
  Dashboard,
  // Charts,
  AdminCheckin,

  // ServerSideReactTable,
  // ReactBootstrapTable,
  // TableWrapper,
  // NoInternetConnection,
} from "./components";

function App() {
  return (
  <div className="App">
    {/* <NoInternetConnection> */}
    <Router>
      {/* <Navigation /> */}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/resetPassword" element={<ResetPassword />} />
        <Route path="/admin-checkin" element={<AdminCheckin />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/otp" element={<Otp />} />
        <Route path="/registerByAdmin" element={<Register />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<SuperAdmin />} />
        <Route path="/profile" element={<Profile />} />


        {/* <Route path="/charts" element={<Charts />} /> */}
        {/* <Route path="/server-side-react-table" element={<ServerSideReactTable />} /> */}
        {/* <Route path="/react-bootstrap-table" element={<ReactBootstrapTable />} /> */}
        {/* <Route path="/user-table" element={<TableWrapper />} /> */}
      </Routes>
      {/* <Footer /> */}
    </Router>
    {/* </NoInternetConnection> */}
  </div>
  );
}

export default App;